import { render, staticRenderFns } from "./CallTranscription.vue?vue&type=template&id=0773865e&scoped=true&"
import script from "./CallTranscription.vue?vue&type=script&lang=ts&"
export * from "./CallTranscription.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./CallTranscription.vue?vue&type=style&index=0&id=0773865e&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0773865e",
  null
  ,true
)

export default component.exports